import React from 'react'

const NamePlate = (props: any) => {
  const { name } = props
  return (
    <span className="f-title-name-plate">
      <div className="f-title">
        <span title="First Folder">{name}</span>
      </div>
    </span>
  )
}

export default NamePlate
